<app-ag-grid-table
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [autopopulateSelect]="autopopulateSelect"
  [columnSelection]="columnSelection"
  [tableParams]="tableParams"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
  [buildParams]="buildParams"
>
</app-ag-grid-table>
